import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { Table } from '@motorway/motorway-storybook-cra';

import proPropTypes from 'Utilities/proPropTypes';

import styles from './ProTable.module.scss';

const ProTable = ({
	alternateRowHighlight,
	children,
	className,
	colGroup,
	containerClassName,
	edgeToEdgeOnMobile,
	tableProps,
}) => (
	<div
		className={cx(styles.proTableContainer, { [styles.edgeToEdgeOnMobile]: edgeToEdgeOnMobile }, containerClassName)}
	>
		<Table className={cx(styles.proTable, className)} hoverable={false} size="full" striped={false} {...tableProps}>
			{colGroup}
			<tbody className={alternateRowHighlight}>{children}</tbody>
		</Table>
	</div>
);

ProTable.defaultProps = {
	alternateRowHighlight: 'odd',
	children: null,
	className: '',
	colGroup: null,
	containerClassName: '',
	edgeToEdgeOnMobile: false,
	tableProps: {},
};

ProTable.propTypes = {
	alternateRowHighlight: PropTypes.oneOf(['odd', 'even', 'none']),
	children: PropTypes.node,
	className: proPropTypes.className,
	colGroup: PropTypes.node,
	containerClassName: proPropTypes.className,
	edgeToEdgeOnMobile: PropTypes.bool,
	tableProps: PropTypes.objectOf(PropTypes.any),
};

export default ProTable;
